import { ga4UserEventParams, trackAnalyticsCustomEvent } from '@ifixit/analytics';

/** Which surface shows the prompt; stored on the saved item as workbench_item.source. */
export const WORKBENCH_PROMPT_SOURCES = ['guide_complete', 'question', 'troubleshooting'] as const;

export type WorkbenchPromptSource = (typeof WORKBENCH_PROMPT_SOURCES)[number];

export type WorkbenchPromptAction = 'View' | 'Save' | 'Pick' | 'Switch' | 'Dismiss' | 'Not Mine';

/** GA4 cuts event names at 40 characters; the longest here is 27. */
export function trackWorkbenchPrompt(
   action: WorkbenchPromptAction,
   { source, owned_count }: { source: WorkbenchPromptSource; owned_count?: number }
): void {
   trackAnalyticsCustomEvent({
      ...ga4UserEventParams(),
      eventCategory: 'Workbench',
      eventAction: `Workbench Prompt - ${action}`,
      source,
      ...(owned_count !== undefined && { owned_count }),
   });
}
